import './App.scss';
import "./pages/PageStructure/PageStyles.scss"
import { useLocation } from 'react-router-dom';
import { PageMasterTemplate as MasterTemplate } from './pages/PageStructure/PageMaster';
import { PageRoutes as Routes } from './pages/PageStructure/PageRoutes';
import { ErrorBoundary } from './components/ui/ErrorBoundary';

import { BootstrapThemeProvider } from './contexts/BootstrapThemeContext';

function App() {
  const location = useLocation();

  return (
    <BootstrapThemeProvider>
      <MasterTemplate >
        <ErrorBoundary resetKeys={[location.pathname]}>
          <Routes />
        </ErrorBoundary>
      </MasterTemplate>
    </BootstrapThemeProvider>
  );
}

export default App;
